<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="after-picassos-sleeping-peasants">
<h1>After Picasso’s Sleeping Peasants</h1>
<p style="text-indent:5em;">They sleep on shafts of grain, detached, Though his firm hand lays its red touch On her restfully upraised arm.</p>
<p style="text-indent:5em;">He shades himself from the high sun With the straw hat of the sower.</p>
<p style="text-indent:5em;">His hard-edged elbow embedded In hay carves its niche like a plow.</p>
<br/>
<p style="text-indent:5em;">She opens herself to the sun, Opens the green vale of her skirt,</p>
<p style="text-indent:5em;">Opens the cream clouds of her shirt, Opens the two-petaled flower</p>
<p style="text-indent:5em;">Of her small mouth to the high sun.</p>
<p style="text-indent:5em;">Pure and intact, they dream paused dreams At peace in the creative act.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?e77c0090